export const formatDate = (dateString) => {
  const date = new Date(dateString)

  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }

  return date.toLocaleString('fr-FR', options)
}

export const convertDateFromInput = (date) => {
  if (!date) return null

  const parsedDate = new Date(date)

  if (isNaN(parsedDate.getTime())) {
    return null
  }

  const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000)

  return localDate.toISOString().split('T')[0]
}

export const normalizeDate = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export const isSameDay = (date1, date2) => {
  const normalizedDate1 = normalizeDate(date1)
  const normalizedDate2 = normalizeDate(date2)

  return normalizedDate1.getTime() === normalizedDate2.getTime()
}

export const parseDateOnly = (value) => {
  if (!value) return null
  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return null
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  return Number.isNaN(date.getTime()) ? null : date
}

export const addDateOnlyDays = (value, days) => {
  const date = parseDateOnly(value)
  if (!date || !Number.isFinite(Number(days))) return null
  date.setDate(date.getDate() + Number(days))
  return date
}

export const getDateOnlyRemainingDays = (value, today = new Date()) => {
  const endDate = parseDateOnly(value)
  const currentDate = parseDateOnly(today)
  if (!endDate || !currentDate) return null

  const endUtc = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
  const currentUtc = Date.UTC(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  )
  return Math.round((endUtc - currentUtc) / 86400000)
}
